<div class="container-fluid">
  <!-- Breadcrumb -->
  <app-pagetitle title="Department" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <!-- Add Shift Button -->
  <div class="d-flex justify-content-end" *ngIf="!initalClick">
    <button *ngIf="loginRole == 'SUPERADMIN'" class="btn btn-primary" (click)="isAdd = true; addFun()">
      Add Department
    </button>
  </div>

  <!-- Display Existing Shifts -->
  <div class="row mt-2" *ngIf="shiftsArr?.length != 0 && !isAdd">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0">
            <thead class="thead-dark">
                <tr>
                  <th> Department Name </th>
                  <th> Shift </th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody >
                <tr *ngFor="let item of shiftsArr; let i = index">
                  <td scope="row">{{ item.departmentName }}</td>
                  <td *ngIf="item.isDepartmentShift == true">
                    <i class="mdi mdi-eye"
                      title="View shift"
                      style="cursor: pointer;" (click)="openModalShift(shift, item)"></i>
                  </td>
                  <td *ngIf="item.isDepartmentShift != true">--</td>
                  <td>
                    <a (click)="edit(item, 'edit')" class="mr-3 text-primary" v-b-tooltip.hover title="Edit"
                      style="cursor: pointer">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>

                    <!-- <i class="mdi mdi-pencil font-size-18" style="cursor: pointer"  (click)="edit(item, 'edit')"></i> -->
                    <a [hidden]="loginRole == 'CUSTOMER' || shiftsArr.length == 1" class="text-danger" v-b-tooltip.hover
                      title="Delete" style="cursor: pointer" (click)="openModal(deletetemp, item.id)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                    <!-- <i class="mdi mdi-trash-can font-size-18 ml-2" style="cursor: pointer"
                      (click)="openModal(deletetemp, item.id)"></i> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="shiftsArr?.length == 0 && !isAdd">
    <span><strong>No Depatment Found. Please Add Department</strong></span>
  </div>

  <!-- Add/Edit Shift Form -->
  <div class="row mt-2" *ngIf="isAdd">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Department Configuration</h4>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="departmentName">Department Name</label>
                <input type="text" [(ngModel)]="departmentName" [ngModelOptions]="{standalone: true}"
                  id="departmentName" required #deptInput="ngModel" name="departmentName" class="form-control"
                  placeholder="Department Name" [ngClass]="{ 'is-invalid': submit && deptInput.invalid }" />
                <div *ngIf="submit && deptInput.invalid" class="invalid-feedback d-block">
                  <span *ngIf="deptInput.errors?.required">Please enter a department name.</span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="departmentShift">Department Shift</label>
                <div>
                  <ui-switch defaultBoColor="#dfdfdf" size="small" color="#f46a6a" [checked]="isDepartmentShift"
                    (change)="onShiftToggle()" class="mt-3" style="margin-top: 10px;" aria-label="Toggle shift type">
                  </ui-switch>
                </div>

              </div>
            </div>
            <div class="col-md-4" *ngIf="shiftsArr2.lenght !== 0">
              <div class="form-group" *ngIf="isDepartmentShift && add ">
                <label for="department">Existing Shift</label>
                <select class="form-control" id="department" [(ngModel)]="selectedDepartShift"
                  [ngModelOptions]="{standalone: true}"
                  (change)="onShiftSelect(selectedDepartShift)"
                   required #deptInput="ngModel" placeholder="Select Shift">
                  <option value="New" selected>New</option>
                  <option *ngFor="let shift of shiftsArr2" [value]="shift.departmentName">
                    {{ shift.departmentName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <form [formGroup]="validationform" autocomplete="off" *ngIf="isDepartmentShift">
            <div formArrayName="shifts">
              <div *ngFor="let shiftGroup of shiftForms.controls; let i = index" [formGroupName]="i">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Shift Name</label>
                      <input formControlName="shiftName" class="form-control" placeholder="Shift Name" [ngClass]="{
                          'is-invalid': submit && shiftGroup.get('shiftName')?.errors
                        }" />
                      <div *ngIf="submit && shiftGroup.get('shiftName')?.errors" class="invalid-feedback">
                        <span *ngIf="shiftGroup.get('shiftName')?.errors?.required">
                          Please provide a shift name.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Start Time(HH:MM)</label>
                      <select class="form-control" [attr.id]="'validationCustom03_' + i" id="validationCustom03"
                        formControlName="startTime" placeholder="Start Time">
                        <option value="" disabled selected>Select Time</option>
                        <option *ngFor="let time of selectValue2[i]; let k = index" [value]="time">
                          {{ time }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>End Time(HH:MM)</label>
                      <select class="form-control" [attr.id]="'validationCustom04_' + i" id="validationCustom04"
                        formControlName="endTime" placeholder="End Time" (change)="check24($event.target.value)">
                        <option value="" disabled selected>Select Time</option>
                        <option *ngFor="let time of selectValue2[i]; let index = index" [value]="time">
                          {{ time }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Planned Downtime Section -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        <input type="checkbox" formControlName="checkplanned" (click)="downtimeAdd($event,i)" />
                        Is Planned Downtime
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="shiftGroup.get('checkplanned').value" formArrayName="planneddowntime">
                  <div *ngFor="
                      let downtimeGroup of shiftGroup.get('planneddowntime').controls;
                      let j = index
                    " [formGroupName]="j">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Downtime Name</label>
                          <input formControlName="downtimename" class="form-control" placeholder="Name" [ngClass]="{
                            'is-invalid': submit && downtimeGroup.get('downtimename')?.invalid
                          }" />
                          <div *ngIf="submit && downtimeGroup.get('downtimename')?.errors" class="invalid-feedback">
                            <span *ngIf="downtimeGroup.get('downtimename')?.errors?.required">
                              Please provide a downtime name.
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Duration(HH:MM)</label>
                          <select class="form-control" [attr.id]="'validationCustom06_' + i" id="validationCustom06"
                            formControlName="duration" placeholder="Duration">
                            <option value="" selected disabled>
                              Select Time
                            </option>
                            <option *ngFor="let time of shiftInterval" [value]="time">
                              {{ time }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Start Time(HH:MM)</label>
                          <select class="form-control" [attr.id]="'validationCustom07_' + i" id="validationCustom07"
                            formControlName="plannedstarttime" placeholder="Start time"
                            (change)="plannedendTime($event,i)">

                            <option value="" selected disabled>
                              Select Time
                            </option>
                            <option *ngFor="
                              let time of plannedInterval2[i];
                              let j = index
                            " [value]="time" [attr.hidden]="isOptionDisabled(j) ? true : null">
                              {{ time }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- <div class="col-md-3">
                        <div class="form-group">
                          <label>End Time</label>
                          <input type="time" formControlName="plannedendtime" class="form-control" />
                        </div>
                      </div> -->
                      <div style="display: flex; justify-content: center;align-items: center;margin-top: 10px;">
                        <button class="btn btn-danger" (click)="removeRow(i,j)">
                          X
                        </button>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn-primary" [disabled]="isLimit"
                    (click)="getInterval(i);addPlannedDowntime(i)">
                    Add Downtime
                  </button>
                </div>
                <hr>
              </div>
            </div>

            <button type="button" class="btn btn-primary" [disabled]="(is24 || isLimit)" (click)="addNewShift()">
              Add Next Shift
            </button>

            <button type="button" class="btn btn-danger ml-1" (click)="removeLastShift()"
              [disabled]="shiftsFormArray.length <= 1">
              Delete Last Shift
            </button>

            <button type="button" class="btn btn-success ml-1" [disabled]="(same || isLimit)" (click)="saveAllShifts()">
              Save
            </button>

            <button type="button" class="btn btn-danger ml-1" (click)="cancel()">
              Cancel
            </button>
          </form>
          <div class="text-right">
            <button *ngIf="!isDepartmentShift" type="submit" class="btn btn-success" (click)="save()">Save</button>
            <button *ngIf="!isDepartmentShift" type="button" class="btn btn-danger ml-1" (click)="cancel2()">
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>


<ng-template #deletetemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Delete Department</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <form>
        <div>
          <p>Are you sure to Delete?</p>
        </div>
        <button type="submit" class="btn btn-danger round waves-effect headr" (click)="delete(delShiftId)">
          Delete
        </button>
        &nbsp;
        <button type="submit" class="btn btn-info round waves-effect headr" (click)="modal('Cross click')">
          Cancel
        </button>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #shift role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Shift Info</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click'); closeView()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <div class="row mt-2">
        <div class="col-lg-12">
          <h4 class="card-title">Department Configuration</h4>
          <form [formGroup]="validationform" autocomplete="off">
            <div class="col-md-4 form-group">
              <label for="departmentName">Department Name</label>
              <input type="text" [disabled]="!isAdd" [(ngModel)]="departmentName" [ngModelOptions]="{standalone: true}"
                id="departmentName" name="departmentName" class="form-control" placeholder="Department Name" />
            </div>
            <div formArrayName="shifts">
              <div *ngFor="let shiftGroup of shiftForms.controls; let i = index" [formGroupName]="i">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Shift Name</label>
                      <input formControlName="shiftName" class="form-control" placeholder="Shift Name" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Start Time</label>
                      <select class="form-control" [attr.id]="'validationCustom03_' + i" id="validationCustom03"
                        formControlName="startTime" placeholder="Start Time">
                        <option value="" disabled selected>Select Time</option>
                        <option *ngFor="let time of selectValue2[i]; let k = index" [value]="time">
                          {{ time }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>End Time</label>
                      <select class="form-control" [attr.id]="'validationCustom04_' + i" id="validationCustom04"
                        formControlName="endTime" placeholder="End Time" (change)="check24($event.target.value)">
                        <option value="" disabled selected>Select Time</option>
                        <option *ngFor="let time of selectValue2[i]; let index = index" [value]="time">
                          {{ time }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Planned Downtime Section -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        <input type="checkbox" formControlName="checkplanned" (click)="downtimeAdd($event,i)" />
                        Is Planned Downtime
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="shiftGroup.get('checkplanned').value" formArrayName="planneddowntime">
                  <div *ngFor="
                          let downtimeGroup of shiftGroup.get('planneddowntime').controls;
                          let j = index
                        " [formGroupName]="j">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Downtime Name</label>
                          <input formControlName="downtimename" class="form-control" placeholder="Name" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Duration</label>
                          <select class="form-control" [attr.id]="'validationCustom06_' + i" id="validationCustom06"
                            formControlName="duration" placeholder="Duration">
                            <option value="" selected disabled>
                              Select Time
                            </option>
                            <option *ngFor="let time of shiftInterval" [value]="time">
                              {{ time }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Start Time</label>
                          <select class="form-control" [attr.id]="'validationCustom07_' + i" id="validationCustom07"
                            formControlName="plannedstarttime" placeholder="Start time"
                            (change)="plannedendTime($event,i)">

                            <option value="" selected disabled>
                              Select Time
                            </option>
                            <option *ngFor="
                                  let time of plannedInterval2[i];
                                  let j = index
                                " [value]="time" [attr.hidden]="isOptionDisabled(j) ? true : null">
                              {{ time }}
                            </option>
                          </select>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
                <hr>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>
